export { default } from './Contacta';
